import React from "react";
import ReactDOM from "react-dom";
import PlainEditor from "../../../../../../merchant/panel/scripts/shared/editor/plainEditor";
import { useContentDt } from "../../gallery/scripts/useContentDt";
import "./styles.css";
export default function Description(props) {
    const text = props.DTContext ? useContentDt(props.value, props.DTContext) : props.value;
    return ReactDOM.createPortal(React.createElement("div", { className: "description-container" },
        React.createElement("div", { className: "description-closing-container" },
            React.createElement("div", { className: "description-closing", onClick: props.onLeave }, "\u2716")),
        React.createElement(PlainEditor, { onChange: () => { }, editable: false, example: text, update: text, label: "" })), document.querySelector("#consent-description-container"));
}
